import { ColumnBlockComponent } from './column-block.js';
import { ColumnDividerComponent } from './column-divider.js';
import { ColumnsBlockComponent } from './columns-block.js';

const define = (name: string, element: CustomElementConstructor) => {
  // The view extension's effect() can run more than once in tests and in
  // multi-editor hosts; redefining a custom element throws.
  if (!customElements.get(name)) {
    customElements.define(name, element);
  }
};

export function effects() {
  define('affine-columns', ColumnsBlockComponent);
  define('affine-column', ColumnBlockComponent);
  define('affine-column-divider', ColumnDividerComponent);
}
